<template>

    <section class="dd-l-section--question">
        <div class="dd-l-container__wrapper dd-l-container__wrapper--content dd-l-container__wrapper--grid">

            <div class="dd-l-section--question__container">
                <h2 class="dd-l-section--question__title">Perguntas</h2>
                <h3 class="dd-l-section--question__total" v-if="total">{{total}} answered questions</h3>

                <form class="dd-m-form dd-m-form--topic-search"
                      novalidate
                      v-on:submit.prevent="doSearch()"
                      v-if="total">
                    <div class="dd-m-form__icon-input dd-m-form__icon-input--dark">
                        <input placeholder="Search by topic"
                               name="topico"
                               type="text"
                               v-model="search"
                               class="dd-m-form__input dd-m-form__input--custom">
                        <button type="submit"
                                class="dd-m-button dd-m-button--dark dd-m-button--tiny dd-m-helper--centralize">
                            <i class="dd-m-icon icon-search"></i>
                        </button>
                    </div>
                </form>

                <form v-on:submit.prevent="send()" class="dd-m-form">
                    <textarea v-model="question" class="dd-m-form__custom-textarea"
                              placeholder="Ask a question"></textarea>

                    <div class="dd-m-alert dd-m-alert--danger" v-if="errors.length">
                        <span v-for="(item, index) in errors" :key="index">
                            {{item}}
                        </span>
                    </div>

                    <vue-ladda button-class="dd-m-button dd-m-button--auto dd-m-button--light"
                               :loading="isAsking">
                        Submit
                    </vue-ladda>
                </form>

                <questions per-page="3"
                           :product-id="productId"
                           title="Customer Questions & Answers"></questions>
            </div>

        </div>

        <modal-simple-success title="Pergunta enviada com Sucesso" name="client-question"
                              modal-ref="ClientQuestion"></modal-simple-success>
    </section>

</template>
<script>
    import AuthService from '../../providers/api/auth-service';
    import ProductService from '../../providers/api/product-service';
    import Questions from "../pages/product/questions";
    import ModalSimpleSuccess from "../custom-modals/modal-simple-success";

    const productService = new ProductService(),
        authService = new AuthService();

    export default {
        name: 'grid-client-question',
        components: {ModalSimpleSuccess, Questions},
        props: ['productId'],
        mounted() {
            this.getProductQuestions();
        },
        data: () => {
            return {
                total: 0,
                search: null,
                question: null,
                isAsking: false,
                errors: []
            }
        },
        methods: {
            getProductQuestions() {
                productService.doGetQuestionsByProductId(this.productId, {})
                    .then((res) => this.total = res.data.pagination.total);
            },
            send() {
                if (!authService.isSigned()) return PubSub.publish('openLoginModal');
                if (this.question) {
                    this.isAsking = true;
                    this.errors = [];

                    productService.doCreateQuestion(this.productId, this.question)
                        .then(() => {
                            PubSub.publish('openClientQuestionModal');
                            this.question = null;
                            this.isAsking = false;
                        })
                        .catch((err) => {
                            if (err.response && err.response.status === 401) {
                                this.errors = [err.response.data.error.message];
                                PubSub.publish('openLoginModal');
                            }

                            if (err.response && err.response.status === 422) {
                                const errValidations = err.response.data.error.validations;
                                for (const j in errValidations) {
                                    if (errValidations.hasOwnProperty(j)) {
                                        this.errors = errValidations[j];
                                    }
                                }
                            }

                            this.isAsking = false;
                        });
                }
            },
            doSearch() {
                PubSub.publish('searchQuestion', this.search);
                this.smooth();
            },
            smooth() {
                if ($("#dd-questions").length) {
                    $('html, body').animate({
                        scrollTop: $("#dd-questions").offset().top
                    }, 200);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/grids/grid-client-question.vue